import { ACTIVE_ORDER_STATUSES } from 'constants/order'
import { ResolutionId } from 'types/order'

export interface OrderStatusChangeItem {
  orderNumber: string
  resolution: string
}

/**
 * Текст для уведомления клиенту о новом статусе (по резолюции заявки).
 */
export const formatOrderStatusNotificationBody = (items: OrderStatusChangeItem[]): string => {
  const clarify: string[] = []
  const inWork: string[] = []
  const completed: string[] = []

  items.forEach(({ orderNumber, resolution }) => {
    const r = String(resolution) as ResolutionId

    if (r === ResolutionId.CLARIFY_DATA) {
      clarify.push(orderNumber)
      return
    }

    if (ACTIVE_ORDER_STATUSES.includes(r)) {
      inWork.push(orderNumber)
      return
    }

    completed.push(orderNumber)
  })

  const lines: string[] = []
  if (clarify.length === 1) lines.push(`Уточните данные заявки ${clarify[0]}`)
  if (clarify.length > 1) lines.push(`Уточните данные у заявок: ${clarify.join(', ')}`)

  if (inWork.length === 1) lines.push(`Заявка ${inWork[0]} в работе`)
  if (inWork.length > 1) lines.push(`Заявки в работе: ${inWork.join(', ')}`)

  if (completed.length === 1) lines.push(`Заявка ${completed[0]} завершена`)
  if (completed.length > 1) lines.push(`Заявки завершены: ${completed.join(', ')}`)

  return lines.join('\n')
}
